export default __webpack_public_path__ + "static/media/icons8-cd.0b4389e2.gif";